import React from 'react';
import CreateDropDown from './createDropDownLink';
import shortid from 'shortid';

const dropDownColumn = props => {
  return (
    <div className="menu-column">
      <ul>
        {props.categories.length > 0 &&
          props.categories.map(category => (
            <CreateDropDown {...category} key={shortid.generate()} />
          ))}
      </ul>
    </div>
  );
};

export default dropDownColumn;
